import { useUnityContext as useBaseUnity } from 'react-unity-webgl';
import useVHUnityUrl from './useVHUnityUrl';

export const useVHUnityContext = () => {
  const url = useVHUnityUrl();
  const context = useBaseUnity({
    loaderUrl: `${url}WebGL-PD_2020.loader.js`,
    dataUrl: `${url}WebGL-PD_2020.data.unityweb`,
    frameworkUrl: `${url}WebGL-PD_2020.framework.js.unityweb`,
    codeUrl: `${url}WebGL-PD_2020.wasm.unityweb`,
  });

  return context;
};

export default useVHUnityContext;
